export const inspectList = [
  {
    content: "안전관리자 지정 여부",
    isChecked: "",
    title: "안전보건 관리조직 및 교육",
  },
  {
    content: "보건관리자 지정 여부",
    isChecked: "",
    title: "안전보건 관리조직 및 교육",
  },
  {
    content: "안전보건교육 실시 여부",
    isChecked: "",
    title: "안전보건 관리조직 및 교육",
  },
  {
    content: "교육결과 기록보존상태",
    isChecked: "",
    title: "안전보건 관리조직 및 교육",
  },
  {
    content: "안전관리비 적정계상 여부",
    isChecked: "",
    title: "산업안전 보건관리비",
  },
  {
    content: "안전관리비 집행실태(타목적, 용도외 사용 등)",
    isChecked: "",
    title: "산업안전 보건관리비",
  },
  {
    content: "항목별 적정비율 집행 여부",
    isChecked: "",
    title: "산업안전 보건관리비",
  },
  {
    content: "보호구 적격품(검정) 구입 여부",
    isChecked: "",
    title: "개인보호구 지급",
  },
  {
    content: "개인보호구 지급 여부",
    isChecked: "",
    title: "개인보호구 지급",
  },
  {
    content: "개인보호구 착용 여부 (방진마스크, 귀마개, 안전모, 안전대, 안전화 등)",
    isChecked: "",
    title: "개인보호구 지급",
  },
  {
    content: "유해･위험방지계획서 제출 및 이행 여부 등",
    isChecked: "",
    title: "기타 안전대책",
  },
  {
    content: "위험물(인화성 물질 등) 관리 상태",
    isChecked: "",
    title: "기타 안전대책",
  },
  {
    content: "화재예방 대책(소화기 비치 비상 연락망 편성 등)",
    isChecked: "",
    title: "기타 안전대책",
  },
  {
    content: "위험,주의,경고 등 표지판 설치 상태",
    isChecked: "",
    title: "기타 안전대책",
  },
  {
    content: "작업장 내 자재의 정리 정돈 및 안전통로 확보 상태",
    isChecked: "",
    title: "기타 안전대책",
  },
  {
    content: "안전난간대 설치\n- 안전난간대 포스트(기둥) 및 난간대(중간 45~60cm, 상부 90~120cm) 설치여부\n" +
      "작업발판은 2개소 이상 견고히 고정, 발판 틈 간 사이는 최소 3cm 이내.",
    isChecked: "",
    title: "추락재해 방지시설",
  },
  {
    content: "외부 비계\n- 벽이음 간격 준수여부(수직, 수평간격 5m이내, 최상부 흔들림 여부)",
    isChecked: "",
    title: "비계류",
  },
  {
    content: "이동식 비계등\n- 작업발판 상부 안전난간 설치 유무\n- 작업발판의 강도 및 고정상태\n- 사다리 등 설치 유무\n- 바퀴구동 방지장치 설치 유무",
    isChecked: "",
    title: "비계류",
  },
  {
    content: "안전장치의 설치 및 작동상태(과부하 방지장치 등)",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "인양 와이어 로프의 손상, 변형 유무",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "와이어 로프 결속 클립의 적정성",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "이동식 크레인 아우트리거 설치 상태",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "매달기 작업의 적정성 (W/R 및\\슬링벨트 이상유무, 점검관리 사항)",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "작업반경내 특고압선에 대한 방호조치",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "신호수 배치 여부",
    isChecked: "",
    title: "양중장비(타워크레인, 이동식크레인, 리프트, 승강기 등)",
  },
  {
    content: "B/T 비계 안전작업\n- 안전난간대 중간, 상부 난간 설치 \n- 발판은 500cm 이상 견고, 밀실히 설치 할 것\n- 양방향의 교차가새 설치 및 아웃트리거 설치하여 상부 안전대 고리체결",
    isChecked: "",
    title: "골조, 기계, 전기, 통신공사 등 고소작업대",
  },
  {
    content: "공도구는 사용 전 접지상태 및 점검을 필 할 것",
    isChecked: "",
    title: "골조, 기계, 전기, 통신공사 등 고소작업대",
  },
  {
    content: "우마 안전작업\n- 양 끝단부 발끝막이 인지목(삑삑이, 명끼 등) 설치\n- 접속, 교차부는 견고히 연결, 고정하고, 안전팀 확인 후 사용",
    isChecked: "",
    title: "골조, 기계, 전기, 통신공사 등 고소작업대",
  },
];
